import { translations } from './translations';
import { useStore } from '../state/store';

export function translate(lang, key, vars) {
  const dict = translations[lang] || translations.de;
  let s = dict[key] ?? translations.de[key] ?? key;
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      s = s.replace(new RegExp('\\{' + k + '\\}', 'g'), String(v));
    });
  }
  return s;
}

export function useI18n() {
  const language = useStore((s) => s.language);
  const setLanguage = useStore((s) => s.setLanguage);
  const t = (key, vars) => translate(language, key, vars);
  return { t, language, setLanguage };
}
